import { FC, useCallback, useEffect, useState } from 'react';
import { FileList } from '@microsoft/mgt-react';
import { css } from 'styled-components';
import i18next from 'i18next';
import TestIds from '../../automated-tests-ids/ids';

// microsoftgraph
import { LocalizationHelper } from '@microsoft/mgt';

import DocumentDriveElement from 'saur-viseau-state-management/lib/documents/models/DocumentDriveElement';
import FileListItems, { FileListItemsStyles } from './components/FileListItems';
import Container from 'saur-design-sys-web/lib/Atoms/Container/Container';

/* eslint-disable @typescript-eslint/member-delimiter-style */
interface IProps {
    // Site ID sharepoint recher
    siteid: string;
    // Item ID  microsoft
    itemId: string;
    // La liste des biblotheques
    documentDriveList?: DocumentDriveElement[] | [];
}

/**
 * Composant qui se charge d'afficher la dropdown des bibliotque sharepoint et le contenu de chaque Bibliotheque
 */
const SharepointFileList: FC<IProps> = ({
    siteid,
    itemId,
    documentDriveList = []
}) => {
    LocalizationHelper.strings = {
        _components: {
            login: {
                signInLinkSubtitle: i18next.t('documents.sign_in'),
                signOutLinkSubtitle: i18next.t('documents.sign_out')
            },
            'file-list': {
                showMoreSubtitle: i18next.t('documents.file_list_show_more')
            },
            file: {
                modifiedSubtitle: i18next.t('documents.file_list_modifed')
            }
        }
    };

    const [fileList, setFileList] = useState<any>(null);
    const [nav, setNav] = useState<any>(null);
    const [init, setInit] = useState<any>(false);
    const [initFileList, setInitFileList] = useState<any>(false);
    const [home, setHome] = useState<any>(null);
    const [homeListId, setHomeListId] = useState<any>(null);
    const [driveId, setDriveId] = useState<string>('');
    const [driveName, setDriveName] = useState<any>(null);
    const [sortedDocumentDriveList, setSortedDocumentDriveList] = useState(
        documentDriveList
    );

    const removeListItems = useCallback(
        (n: any) => {
            if (nav) {
                while (nav.getElementsByTagName('li').length > n) {
                    nav.removeChild(nav.lastChild);
                }
            }
        },
        [nav]
    );

	const handleChangeDocumentDrive = (value: any) => { 
		setDriveId(value.value);
		setDriveName(value.label);
		setInitFileList(true);
	
        try {
            setTimeout(function () {
                const mgList = document.querySelector(
                    'mgt-file-list'
                ) as HTMLElement;
                if (mgList) {
                    const fluentDesing = mgList.shadowRoot?.querySelector(
                        'fluent-design-system-provider'
                    );					                    
					const divElements = fluentDesing?.querySelectorAll("#file-list .file-item");
					setLineBackgroundColor(divElements);
                }
            }, 1000);
        } catch (error) {
            console.error(error);
        }
	};

    useEffect(() => {
        setFileList(document.querySelector('mgt-file-list'));
    }, [initFileList]);

    useEffect(() => {
        removeListItems(1);
    }, [driveId, removeListItems]);

    useEffect(() => {
        setFileList(document.querySelector('mgt-file-list'));
        setNav(document.getElementById('nav'));
        setHome(document.getElementById('home'));
    }, []);

    useEffect(() => {
        if (fileList  && typeof fileList.reload === 'function') fileList.reload(true);
        if (fileList?.itemId) {
            setHomeListId(fileList?.itemId);
        } else {
            setHomeListId(null);
        }
    }, [fileList, itemId]);

    useEffect(() => {
        if (fileList && home && nav && !init) {
            setInit(true);
            home.addEventListener('click', (e: any) => {
                fileList.itemId = itemId;
                removeListItems(1);
            });
            fileList.addEventListener('itemClick', (e: any) => {
                if (e.detail && e.detail.file) {
                    window.open(e.detail.webUrl);
                }
                if (e.detail && e.detail.folder) {
                    const id = e.detail.id;
                    const name = e.detail.name;

                    // render new file list
                    fileList.itemId = id;

                    // create breadcrumb menu item
                    const li = document.createElement('li');
                    const span = document.createElement('span');
                    li.setAttribute('id', id);
                    span.appendChild(document.createTextNode(name));
                    li.appendChild(span);
                    nav.appendChild(li);

                    // remove breadcrumb menu items and render file list based on clicked item
                    span.addEventListener('click', (eClick) => {
                        const nodes = Array.from(nav.children);
                        const index = nodes.indexOf(li);
                        if (eClick.target) {
                            removeListItems(index + 1);
                            fileList.itemId = li.id;
                        }
                    });
                }
            });
        }
    }, [
        fileList,
        home,
        nav,
        init,
        homeListId,
        itemId,
        initFileList,
        removeListItems
    ]);

    useEffect(() => {
        documentDriveList.sort((a, b) => SortString(a.label, b.label));
        setSortedDocumentDriveList(documentDriveList);
    }, [documentDriveList]);

    return (
        <Container className='sharepoint-view' automatedTestId={TestIds.sharePoint.SharepointFileList.sharepointFileList}>
            <div className="col-md-4">
				<FileListItems files={sortedDocumentDriveList} onFileItemClick={handleChangeDocumentDrive} />
            </div>
			<div className="col-md-8">
                <ul className='breadcrumb' id='nav'>
                    <li>
                        <span id='home'>
                            {driveName ?? i18next.t('documents.no_drive_selected')}
                        </span>
                    </li>
                </ul>
                {initFileList && (
                    <FileList
                        siteId={siteid}
                        itemId={itemId}
                        driveId={driveId}
                        enableFileUpload={true}
                        excludedFileExtensions={[
                            '.EXE',
                            '.PIF',
                            '.Application',
                            '.gadget',
                            '.MSI',
                            '.MSP',
                            '.COM',
                            '.SCR',
                            '.hta',
                            '.CPL',
                            '.MSC',
                            '.JAR',
                            '.BAT',
                            '.CMD',
                            '.VB',
                            '.vbs',
                            '.VBE',
                            '.JS',
                            '.JSE',
                            '.WS',
                            '.wsf',
                            '.wsc',
                            '.wsh',
                            '.ps1',
                            '.ps1xml',
                            '.PS2',
                            '.PS2XML',
                            '.psc1',
                            '.PSC2',
                            '.msh',
                            '.MSH1',
                            '.MSH2',
                            '.MSHXML',
                            '.MSH1XML',
                            '.MSH2XML',
                            '.scf',
                            '.LNK',
                            '.INF',
                            '.REG'
                        ]}
                    ></FileList>
                )}
            </div>
        </Container>
    );
};

export function SortString(a: string, b: string) {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
};

export function cssSetter(element: any, style: any) {
    for (const property in style)
        element.style[property] = style[property];
}

export function setLineBackgroundColor(divElements: NodeListOf<Element> | undefined) {
    divElements?.forEach((element, index) => {
        let backgroundColorLine = "#FFF";
        let textColorLine = "#000";
        if (index % 2 === 0) {
            backgroundColorLine = "#f3f4f7";
            textColorLine = "#FFF";
        }
        cssSetter(element, {
            'background-color': backgroundColorLine,
            color: textColorLine
        });

    });
}

export default SharepointFileList;

export const SharepointFileListStyles = css`
 .sharepoint-widget {
    .sharepoint-view {
        display: flex;
        flex-direction: row;
		gap: 20px;
		.col-md-4 {
			width: 40%;
		}

		.col-md-8 {
			width: 60%;
		}

        .drives-dropDown-input {
            background-color: #ffffff;
            border-radius: 2px;
            width: 309px;
            height: 50px;
            color: #323232;
            font-family: montserrat-regular;
            font-style: italic;
            font-size: 14px;
            line-height: 17px;
            opacity: 2;
            text-align: left;
        }

        ul.breadcrumb , ul.breadcrumb-2 {
            margin: 0;
            padding: 15px;
            list-style: none;
            font-size: 12px;
            background-color: #1156b2;
            border-radius: 8px 8px 0 0;
            box-shadow: 0 14px 14px 3px rgba(0, 0, 0, 0.05);
            align-self: center;
            margin: 24px 0px 0px;
        }
        ul.breadcrumb li , ul.breadcrumb-2 li {
            display: inline;
        }

        ul.breadcrumb li + li:before , ul.breadcrumb-2 li + li:before {
            padding: 8px;
            color: #eeeeee;
            content: '/';
        }

        ul.breadcrumb li span , ul.breadcrumb-2 li span {
            color: #FFFFFF;
            font-family: montserrat-regular;
            font-size: 14px;
            line-height: 17px;
            text-align: left;
        }

        ul.breadcrumb li span:hover , ul.breadcrumb-2 li span:hover {
            color: #eeeeee;
            cursor: pointer;
            text-decoration: underline;
        }

        mgt-file-list {
            --font-family: montserrat-bold;
            --font-size: 14px;
            --file-item-border-radius: 8px 8px 0 0;
        }
        ${FileListItemsStyles}
    }
    }
    
`;
